export default "__VITE_ASSET__ChRpcFWu__"